/* GC Living — cinematic homepage scroll (Rolex-flavoured).
   1. Reveal: headings/cards fade-up with stagger.
   2. Unveil: large imagery de-zooms + unclips as it enters.
   3. Parallax: hero and feature media drift at depth-dependent speeds.
   JS tags everything after load, so no-JS visitors and crawlers always
   see full content. Respects prefers-reduced-motion. Homepage only. */
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;

  var style = document.createElement('style');
  style.textContent =
    /* fade-up reveal */
    '[data-gc-reveal]{opacity:0;transform:translateY(26px);' +
    'transition:opacity .8s cubic-bezier(.22,.61,.36,1),transform .8s cubic-bezier(.22,.61,.36,1);' +
    'transition-delay:var(--gc-d,0ms)}' +
    '[data-gc-reveal].gc-inview{opacity:1;transform:none}' +
    /* cinematic unveil for imagery */
    '[data-gc-unveil]{overflow:hidden}' +
    '[data-gc-unveil][data-gc-unveil]>img,[data-gc-unveil][data-gc-unveil]>video{transform:scale(1.14);' +
    'clip-path:inset(6% 6% 6% 6%);' +
    'transition:transform 1.25s cubic-bezier(.22,.61,.36,1),clip-path 1.25s cubic-bezier(.22,.61,.36,1);' +
    'transition-delay:var(--gc-d,0ms)}' +
    '[data-gc-unveil][data-gc-unveil].gc-inview>img,[data-gc-unveil][data-gc-unveil].gc-inview>video{transform:scale(1);clip-path:inset(0 0 0 0)}' +
    /* parallax layers */
    '[data-gc-parallax]{will-change:transform}';
  document.head.appendChild(style);

  /* ---------- 1 & 2: reveal + unveil ---------- */
  var REVEAL = [
    'h1', 'h2',
    '.gc-night-cta-row', '.gc-est-card', '.gc-proof-points',
    '.gc-proc-step', '.gc-proc-footer',
    '.card-wrapper', '.article-card',
    '.image-with-text__grid', '.banner__box', '.newsletter__wrapper'
  ].join(',');
  var UNVEIL = ['.gc-night-card', '.gc-proof-card'].join(',');

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('gc-inview');
        io.unobserve(entry.target);
      }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

  document.querySelectorAll('main .shopify-section').forEach(function (section) {
    var i = 0;
    Array.prototype.slice.call(section.querySelectorAll(REVEAL))
      .filter(function (el) { return !el.closest('.swiper, .swiper-wrapper, #gc-trust-grid'); })
      .slice(0, 12)
      .forEach(function (el) {
        el.setAttribute('data-gc-reveal', '');
        el.style.setProperty('--gc-d', Math.min(i++ * 90, 450) + 'ms');
        io.observe(el);
      });
    Array.prototype.slice.call(section.querySelectorAll(UNVEIL))
      .filter(function (el) { return !el.closest('.swiper, .swiper-wrapper'); })
      .slice(0, 6)
      .forEach(function (el, j) {
        el.setAttribute('data-gc-unveil', '');
        el.style.setProperty('--gc-d', Math.min(j * 140, 420) + 'ms');
        io.observe(el);
      });
  });

  /* ---------- 3: parallax ---------- */
  var layers = [];

  function tag(el, speed, zoom) {
    if (!el) return;
    el.setAttribute('data-gc-parallax', '');
    layers.push({ el: el, speed: speed, zoom: zoom || 0 });
  }

  /* hero: first section's media drifts down-slow + slowly zooms */
  var hero = document.querySelector('main .shopify-section:first-child');
  if (hero && window.innerWidth >= 750) {
    hero.querySelectorAll('.banner__media img, .banner__media video, video, .media img').forEach(function (m) {
      if (!m.closest('[data-gc-parallax]')) tag(m, 0.1, 0.05);
    });
  }
  /* scroll-driven nightfall for the After Dark band */
  var nights = Array.prototype.slice.call(document.querySelectorAll('.gc-night'));
  nights.forEach(function (n) { n.style.setProperty('--gcnp', '0'); });

  /* full-page veil: the whole page dims as the band arrives, and the
     band itself floats above the veil like a lit stage */
  var veil = null;
  if (nights.length) {
    veil = document.createElement('div');
    veil.id = 'gc-nightfall-veil';
    /* zero-width space defeats the theme's empty-div hiding rule */
    veil.appendChild(document.createTextNode('​'));
    veil.style.cssText =
      'position:fixed;inset:0;background:#05070f;opacity:0;' +
      'pointer-events:none;z-index:5;will-change:opacity;display:block';
    document.body.appendChild(veil);
    nights.forEach(function (n) {
      var sec = n.closest('.shopify-section') || n;
      sec.style.position = 'relative';
      sec.style.zIndex = '6';
    });
  }

  /* oversized outline words drift sideways as their band scrolls through */
  var words = Array.prototype.slice.call(document.querySelectorAll('.gc-bigword'));
  words.forEach(function (w, i) { w.__dir = i % 2 ? 1 : -1; });

  var vh = window.innerHeight;

  function clamp01(x) { return Math.min(Math.max(x, 0), 1); }

  function frame() {
    words.forEach(function (w) {
      var r = w.getBoundingClientRect();
      if (r.bottom < -60 || r.top > vh + 60) return;
      var p = clamp01((vh - r.top) / (vh + r.height));
      w.style.transform = 'translateX(' + ((p - 0.5) * 140 * w.__dir).toFixed(1) + 'px)';
    });
    var veilTarget = 0;
    nights.forEach(function (n) {
      var r = n.getBoundingClientRect();
      if (r.bottom < -40 || r.top > vh + 40) {
        if (r.bottom < -40) n.style.setProperty('--gcnp', '1');
        return;
      }
      /* daylight while the band's top is low in the viewport; fully
         night by the time its top reaches ~30% of the screen */
      var entry = clamp01((vh * 0.92 - r.top) / (vh * 0.62));
      n.style.setProperty('--gcnp', entry.toFixed(3));
      /* page veil: follows entry, releases as the band scrolls away */
      var exit = clamp01((r.bottom - vh * 0.2) / (vh * 0.45));
      veilTarget = Math.max(veilTarget, Math.min(entry, exit));
    });
    if (veil) veil.style.opacity = (veilTarget * 0.82).toFixed(3);
    layers.forEach(function (l) {
      var r = l.el.getBoundingClientRect();
      if (r.bottom < -80 || r.top > vh + 80) return;
      /* hero: drift down slowly + slow zoom over the first viewport.
         Base scale 1.18 keeps the media covering its box; the shift is
         capped below the resulting headroom so no gap ever opens. */
      var p = Math.min(Math.max(window.scrollY / vh, 0), 1);
      var shift = Math.min(window.scrollY * l.speed, 60);
      l.el.style.transform =
        'translateY(' + shift.toFixed(1) + 'px)' +
        ' scale(' + (1.18 + p * l.zoom).toFixed(3) + ')';
    });
  }

  /* Self-scheduling render loop: no reliance on scroll events, so the
     effect can never get stuck. Work per frame is 1-2 rect reads; the
     browser pauses rAF automatically when the tab is hidden. */
  function loop() {
    frame();
    requestAnimationFrame(loop);
  }

  if (layers.length || nights.length) {
    window.addEventListener('resize', function () { vh = window.innerHeight; }, { passive: true });
    requestAnimationFrame(loop);
  }
})();
